<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="dialogClose" width="600px">
    <el-form :model="form" label-width="110px" label-position="right" :rules="rules" ref="ruleForm" class="mt20">
      <el-form-item label="库房名称：" prop="warehouseName">
        <el-input v-model="form.warehouseName" size="mini" placeholder="请输入库房名称" />
      </el-form-item>
      <el-form-item label="所在区域：" prop="areaId">
        <el-cascader v-model="form.areaId" filterable :options="areaList" :props="cascaderProps" size="mini" collapse-tags clearable placeholder="请选择所在区域" class="w100" />
      </el-form-item>
      <el-form-item label="详细地址：" prop="address">
        <el-input v-model="form.address" size="mini" placeholder="请输入详细地址" />
      </el-form-item>
      <el-form-item label="供应商类型：" prop="type">
        <!-- <el-button size="mini" @click="onClickType(1)">公路供应商</el-button>
        <el-button size="mini" @click="onClickType(2)">水路供应商</el-button>
        <el-button size="mini" @click="onClickType(3)">港口及其它供应商</el-button> -->
        <el-select v-model="activeType" placeholder="请选择类型" @change="handelChangeType" size="mini">
          <el-option label="公路供应商" value="1"></el-option>
          <el-option label="水路供应商" value="2"></el-option>
          <el-option label="港口及其它供应商" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属供应商：" prop="supplierIds">
        <el-select v-model="form.supplierIds" size="mini" filterable style="width: 100%" collapse-tags placeholder="请选择所属供应商" value-key="id">
          <el-option v-for="item in supplierOptions" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="面积：" prop="square">
        <el-input v-model="form.square" size="mini" type="number" placeholder="请输入面积" />
      </el-form-item>
      <div class="flex-center-center mt20">
        <el-button size="medium" class="searchBtn" :loading="submitLoading" @click="submit">确认 </el-button>
        <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { getSupplier, warehouseManagementAdd, warehouseManagementUpdate } from '@/service/warehouse';
  import { getSessionStore } from '@/config/mUtils';

  export default {
    name: 'warehouseManagementForm',
    data() {
      return {
        activeType: '',
        dialogVisible: false,
        dialogTitle: '新增',
        defaultForm: {},
        form: {},
        rules: {
          warehouseName: [
            {
              required: true,
              message: '请输入库房名称',
              trigger: 'blur',
            },
          ],
          areaId: [
            {
              required: true,
              message: '请选择所在区域',
              trigger: 'blur',
            },
          ],
          address: [
            {
              required: true,
              message: '请输入详细地址',
              trigger: 'blur',
            },
          ],
          supplierIds: [
            {
              required: true,
              message: '请选择所属供应商',
              trigger: 'blur',
            },
          ],
          square: [
            {
              required: true,
              message: '请输入面积',
              trigger: 'blur',
            },
          ],
        },
        submitLoading: false,
        supplierOptions: [],
        areaList: [],
        cascaderProps: {
          expandTrigger: 'hover',
          value: 'id',
          label: 'cityName',
          children: 'children',
          multiple: false,
        },
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
      this.areaList = JSON.parse(getSessionStore('areaList'));
      // this.getSupplier();
    },
    methods: {
      handelChangeType(type) {
        // console.log(type);
        this.onClickType(type)
      },
      async onClickType(type) {
        const { data, status, message } = await getSupplier({supplierType: type});
        if (status !== 0) return this.$message.warning(message);
        this.supplierOptions = data;
      },
      async getSupplier() {
        const { data, status, message } = await getSupplier();
        if (status !== 0) return this.$message.warning(message);
        this.supplierOptions = data;
      },
      dialogOpen(title, row) {
        this.dialogTitle = title;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        if (row) {
          this.form = row;
          this.form.supplierIds = row.supplierId;
        }
        this.supplierOptions = [];
        this.activeType = '';
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
      },
      submit() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            let data;
            if (this.form.id) {
              data = await warehouseManagementUpdate({
                ...this.form,
                supplierIds: this.form.supplierIds,
                areaId: typeof this.form.areaId === 'string' ? this.form.areaId : this.form.areaId[this.form.areaId.length - 1],
              });
            } else {
              data = await warehouseManagementAdd({
                ...this.form,
                areaId: this.form.areaId[this.form.areaId.length - 1],
              });
            }
            if (data.status !== 0) return this.$message.warning(data.message);
            this.$message.success(data.message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
